module.exports = __webpack_public_path__ + "img/ogp_pocketorbit_big.310163d4.jpg";